var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9258 0C12.2897 0 0.425781 11.8642 0.425781 26.5C0.425781 41.1361 12.29 53 26.9258 53C41.5616 53 53.4258 41.1358 53.4258 26.5C53.4258 11.8639 41.5616 0 26.9258 0ZM26.9258 26.5L26.9026 4.48454H26.9258C32.7521 4.48454 38.3469 6.7975 42.4724 10.9121L26.9258 26.5Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/PieChart.8ab805c5cc5ba081ff2b38679a966671.svg";
export { ForwardRef as ReactComponent };